/*
 * @Description: 员工主数据相关接口
 */
import { RootObject } from '@/model/rootObject'
import https, { downloadExcel } from '@/utils/https'
import { ContentType, Method } from 'axios-mapper'
import {
  EmployeeInfoModel,
  EmployeeListParamModel, EmployeePageParamModel, CreateEmployeeModel, UpdateEmployeeModel, EmployeePageModel
} from '@/model/master-data/employeeModel'
import networkConfig from '@/config/default/net.config'

const baseUrl = '/base/employee'

export const excelSupplierFileUpload = () => {
  return networkConfig.host + baseUrl + '/import/excel'
}

export const createEmployee = (employeeInfo: CreateEmployeeModel) => {
  return https()
    .request<RootObject<number>>(baseUrl + '/add', Method.POST, employeeInfo, ContentType.json)
}

// export const deleteEmployee = (employeeId: number) => {
//   return https().request<RootObject<number>>(baseUrl + '/delete/' + employeeId, Method.POST, undefined, ContentType.json)
// }

export const updateEmployee = (employeeInfo: UpdateEmployeeModel) => {
  return https()
    .request<RootObject<number>>(baseUrl + '/update', Method.POST, employeeInfo, ContentType.json)
}

export const getEmployeeById = (employeeId: number) => {
  return https()
    .request<RootObject<EmployeeInfoModel>>(baseUrl + '/get/' + employeeId, Method.GET, undefined, ContentType.json)
}

export const getEmployeePageList = (params: EmployeePageParamModel) => {
  return https().request<RootObject<EmployeePageModel>>(baseUrl + '/list', Method.POST, params, ContentType.json)
}

export const getEmployeeAllList = (params: EmployeeListParamModel) => {
  return https().request<RootObject<EmployeeInfoModel[]>>(baseUrl + '/list/all', Method.POST, params, ContentType.json)
}

export const exportEmployeeTemplate = () => {
  return downloadExcel(baseUrl + '/export/excelTemplate', Method.GET, undefined)
}
